import React from "react";
import Modal from "react-bootstrap/Modal";
import UserEditForm from "./UserEditForm";

const UserEditModal = ({ show, userId, onHide, onSaved, allowRoleChange = true }) => (
  <Modal show={show} onHide={onHide} size="lg" centered scrollable>
    <Modal.Header closeButton>
      <Modal.Title>Modifica utente</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {userId && (
        <UserEditForm
          key={userId}
          userId={userId}
          allowRoleChange={allowRoleChange}
          showCancel
          onCancel={onHide}
          onSuccess={(updatedUser) => {
            onSaved(updatedUser);
            onHide();
          }}
        />
      )}
    </Modal.Body>
  </Modal>
);

export default UserEditModal;
